import Block from './Block.js';
import SlideManager from '../util/SlideManager'
import gsap from 'gsap';

export default class Slider extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()
    this.init()
    this.initSlider()
  }

  getElems() {
    super.getElems()
    this.$slider = this.el.querySelector('.b-slider__slider-w')
    this.$cards = this.el.querySelectorAll('.slider-card')
    this.$imgs = this.el.querySelectorAll('.slider-img')
    this.$pagerPrev = this.el.querySelector('.b-slider__pager-prev')
    this.$pagerNext = this.el.querySelector('.b-slider__pager-next')
    this.$cardWrapper = this.el.querySelector('.b-slider__cards')

    this.slides = [];
    for (let i = 0; i < this.$cards.length; i++) {
      const card = this.$cards[i];
      const img = this.$imgs[i]

      if (i === 0) img.style.zIndex = this.$cards.length

      this.slides.push({
        img,
        card
      })
    }
  }

  setWrapperHeight() {
    this.height = 0;
    this.$cards.forEach((element) => {
      if (this.height < element.offsetHeight) this.height = element.offsetHeight
    });
    this.$cardWrapper.style.height = this.height + 'px';
  }

  init() {
    this.zIndex = this.slides.length;
    this.setWrapperHeight()
  }

  bindMethods() {
    super.bindMethods()
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
  }

  events() {
    super.events()
    this.$pagerPrev.addEventListener('click', () => {
      this.prev()
    })
    this.$pagerNext.addEventListener('click', () => {
      this.next()
    })
  }

  resize() {
    this.setWrapperHeight()
  }

  initSlider() {
    this.slider = new SlideManager({
      el: this.$slider,
      length: this.slides.length,
      loop: true,
      callback: (event) => {
        this.oldIndex = event.previous;
        this.currentIndex = event.new;
        this.direction = event.direction;
        this.updateSlider(this.slides[this.oldIndex], this.slides[this.currentIndex]).then(this.slider.done.bind(this.slider))
      }
    })
  }

  cardTl(old, current) {
    const tl = gsap.timeline()

    tl.fromTo(old.card, {
      xPercent: 0
    }, {
      xPercent: -20 * this.direction,
      opacity: 0
    })

    tl.fromTo(current.card, {
      xPercent: 20 * this.direction
    }, {
      xPercent: 0,
      opacity: 1
    }, '+=0.5')

    return tl
  }

  updateSlider(old, current) {
    return new Promise((resolve) => {
      const tl = gsap.timeline({
        onComplete: () => {
          resolve()
          }
      })

      tl.addLabel('start', 0)

      /* eslint-disable prefer-reflect */
      tl.call(() => {
        this.zIndex++
      }, 'start')

      tl.add(this.cardTl(old, current), 'start')

      tl.set(current.img, {
        zIndex: this.zIndex++
      }, 'start')

      tl.fromTo(old.img, {
        xPercent: 0
      }, {
        duration: 1.5,
        ease: 'expo',
        xPercent: -100 * this.direction
      }, 'start')

      tl.fromTo(current.img, {
        xPercent: 100 * this.direction
      }, {
        duration: 1.5,
        ease: 'expo',
        xPercent: 0
      }, 'start')

      tl.fromTo(current.img.querySelector('.image'), {
        scale: 1
      }, {
        duration: 1.25,
        ease: 'expo',
        scale: 1.2
      }, 'start')
    })
  }

  next() {
    this.direction = -1
    this.slider.next()
  }

  prev() {
    this.direction = 1
    this.slider.prev()
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Slider.js